import authFetch from "./fetch";
import { makeRequest } from "./utils";

const routes = {
    sessionPath: () => "api/session"
};

export const logSession = () => makeRequest(authFetch.patch(routes.sessionPath()));